export default [
  { value: "WEEKLY", key: "members.payFrequencies.weekly" },
  { value: "BIWEEKLY", key: "members.payFrequencies.biweekly" },
  { value: "MONTHLY", key: "members.payFrequencies.monthly" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/enums/memberPayFrequencies.js